import apiClient from './client'

export const chatApi = {
  getFlows: async () => {
    const response = await apiClient.get('/chat/flows')
    // Handle both array and object response formats
    if (Array.isArray(response.data)) {
      return response.data
    }
    return response.data?.data || response.data || []
  },

  sendMessage: async (data) => {
    const payload = {
      message: data.message,
      flow_id: data.flowId || null,
    }
    if (data.knowledgeBaseId) {
      payload.knowledge_base_id = data.knowledgeBaseId
    }
    const response = await apiClient.post('/chat/message', payload)
    // Handle response format: { success: true, data: {...} }
    if (response.data?.success && response.data?.data) {
      return response.data.data
    }
    return response.data
  },

  getKnowledgeBaseQuestions: async (platform = 'website', locale = null) => {
    const params = { platform }
    if (locale) {
      params.locale = locale
    }
    const response = await apiClient.get('/chat/knowledge-base-questions', { params })
    // Handle response format: { success: true, data: [...] }
    if (response.data?.success && response.data?.data) {
      return response.data.data
    }
    return response.data || []
  },

  getHistory: async () => {
    const response = await apiClient.get('/chat/history')
    // Handle both array and object response formats
    if (Array.isArray(response.data)) {
      return response.data
    }
    return response.data?.data || response.data || []
  },
}

